import { useEffect, useState } from 'react';

import type { DevelopmentSummaryModel } from '@/domain/models/development.js';
import type { BusinessProcessResponse, ProjectUserResponse } from '@/domain/models/project.js';
import type { DevelopmentController } from '@/presentation/controllers/development-controller.js';
import type { ProjectController } from '@/presentation/controllers/project-controller.js';

type ProjectRef = { id: string } | null;

export function useDevelopmentFormLookups(
    projectController: ProjectController,
    controller: DevelopmentController,
    selectedProject: ProjectRef,
    currentUserId: string | undefined,
    setConsultorId: (id: string) => void
) {
    const [businessProcesses, setBusinessProcesses] = useState<BusinessProcessResponse[]>([]);
    const [consultores, setConsultores] = useState<ProjectUserResponse[]>([]);
    const [keyUsers, setKeyUsers] = useState<ProjectUserResponse[]>([]);
    const [projectDevelopments, setProjectDevelopments] = useState<DevelopmentSummaryModel[]>([]);

    useEffect(() => {
        if (!selectedProject) {
            return;
        }
        projectController.listActiveBusinessProcesses(selectedProject.id).then((result) => {
            result.fold(
                () => setBusinessProcesses([]),
                (processes) => setBusinessProcesses(processes)
            );
        });
        projectController.listProjectUsers(selectedProject.id, 'CF').then((result) => {
            result.fold(
                () => setConsultores([]),
                (users) => {
                    setConsultores(users);
                    if (currentUserId && users.some((user) => user.id === currentUserId)) {
                        setConsultorId(currentUserId);
                    }
                }
            );
        });
        projectController.listProjectUsers(selectedProject.id, 'UC').then((result) => {
            result.fold(
                () => setKeyUsers([]),
                (users) => setKeyUsers(users)
            );
        });
        controller.loadDevelopments({ projectId: selectedProject.id, limit: 100 }).then((result) => {
            result.fold(
                () => setProjectDevelopments([]),
                (data) => setProjectDevelopments(data.data)
            );
        });
    }, [projectController, controller, selectedProject, currentUserId, setConsultorId]);

    return { businessProcesses, consultores, keyUsers, projectDevelopments };
}
